import styled from 'styled-components'

import BankImage from 'assets/images/bank-link.png'
import Layout from 'components/Layout'
import { Heading2 } from 'components/Typography'
import { TestIDs } from 'test/utils/testIds'
import { style } from 'theme'

export const Container = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  margin-top: 60px;
  margin-bottom: 110px;
  align-items: center;

  & .ThiccContainer {
    box-shadow: 0px 3px 15px 2px rgba(0, 0, 0, 0.05);
    max-width: 340px;

    & button {
      padding: 15px 10px;

      & div:nth-child(2) {
        margin-left: 6px;
        flex-wrap: wrap;
        width: 300px;

        & p {
          margin-left: 0px;
          text-align: left;
        }

        & p:nth-child(2) {
          font-size: 12px;
        }
      }
    }
  }
`

export const Title = styled(Heading2)`
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 10px;
`

export const TitleLater = styled(Title)`
  line-height: 24px;
  margin-bottom: 4px;
`

export const Text = styled.div`
  font-size: 14px;
  line-height: 22px;
  margin: 0 auto 60px;
  max-width: 340px;

  @media (min-width: ${style(theme => theme.breakpoints.md)}px) {
    margin: 0 auto 80px;
  }
`

export const TextLater = styled(Text)`
  margin-bottom: 80px;

  @media (max-width: ${style(theme => theme.breakpoints.md)}px) {
    margin-bottom: 80px;
  }

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    margin-bottom: 60px;
  }
`

export const CoreImage = styled.img.attrs({
  'data-testid': TestIDs.FUNDING_PAGE.CORE_IMAGE,
})`
  max-width: 100%;
  height: 140px;
  margin: 30px auto 20px;
`

export const LaterImage = styled.div.attrs({
  'data-testid': TestIDs.FUNDING_PAGE.LATER_IMAGE,
})`
  background: rgb(255, 255, 255);
  height: 110px;
  width: 160px;
  background-image: url(${BankImage});
  background-position: center;
  background-repeat: no-repeat;
  margin: 0 auto 20px;
  background-size: contain;
`

export const Footnote = styled.div`
  text-align: center;
  padding-bottom: 20px;
  padding-top: 20px;
  max-width: 450px;
  font-size: 12px;
  line-height: 16px;
  color: ${style(theme => theme.colors.stone)};
  position: sticky;
  bottom: 0px;
  background-color: ${style(theme => theme.colors.white)};

  @media screen and (min-width: ${style(theme => theme.breakpoints.sm + 1)}px) {
    display: none;
  }
`

export const StyledButton = styled.div`
  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    background-color: white;
    position: sticky;
    bottom: 0px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`

export const AnimationContainer = styled.div`
  max-width: 250px;
  width: 100%;
  margin: 0 auto;
  position: relative;
  max-height: 180px;
`

export const LayoutNoMobilePadding = styled(Layout)`
  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    padding-bottom: 0px;
  }
`
